import React from 'react'
import {BrowserRouter} from 'react-router-dom'
import AppRoutes from './AppRoutes'

const Router = () => {
    
    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    )
}

export default Router